import { render } from "./ProfileList.vue?vue&type=template&id=51be15a6&scoped=true"
import script from "./ProfileList.vue?vue&type=script&lang=js"
export * from "./ProfileList.vue?vue&type=script&lang=js"

import "./ProfileList.vue?vue&type=style&index=0&id=51be15a6&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51be15a6"]])

export default __exports__